import React from 'react';
export function CookiesPage() {
  return <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-436">
      <div className="max-w-3xl mx-auto" data-id="element-437">
        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-438">
          Política de Cookies
        </h1>

        <div className="space-y-6 text-base text-gray-600 leading-relaxed" data-id="element-439">
          <div className="text-center mb-8" data-id="element-440">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-441">
              Política de Cookies de ClubAhorra, Benefika y TicketMaestro
            </h2>
          </div>

          <section data-id="element-442">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-443">
              1. INTRODUCCIÓN
            </h3>
            <p data-id="element-444">
              En ClubAhorra, Benefika y TicketMaestro, utilizamos cookies y
              tecnologías similares para mejorar la experiencia de navegación en
              nuestros sitios web, analizar el tráfico, personalizar el
              contenido y mostrar anuncios relevantes. A continuación, te
              explicamos qué son las cookies, cómo las usamos y cómo puedes
              gestionarlas.
            </p>
          </section>

          <section data-id="element-445">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-446">
              2. ¿QUÉ SON LAS COOKIES?
            </h3>
            <p data-id="element-447">
              Las cookies son pequeños archivos de texto que un sitio web
              almacena en tu dispositivo (computadora, celular o tablet) al
              visitarlo. Estas permiten que el sitio "recuerde" tus acciones o
              preferencias (como idioma, inicio de sesión, etc.) durante un
              período de tiempo determinado.
            </p>
          </section>

          <section data-id="element-448">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-449">
              3. ¿QUÉ TIPOS DE COOKIES UTILIZAMOS?
            </h3>

            <div className="space-y-4 mt-4" data-id="element-450">
              <div data-id="element-451">
                <p className="font-semibold text-gray-800 mb-1" data-id="element-452">
                  A. Cookies necesarias (técnicas):
                </p>
                <p data-id="element-453">
                  Permiten la navegación en el sitio web y el uso de sus
                  funciones esenciales. Sin estas cookies, el sitio no puede
                  funcionar correctamente.
                </p>
              </div>

              <div data-id="element-454">
                <p className="font-semibold text-gray-800 mb-1" data-id="element-455">
                  B. Cookies de preferencia o personalización:
                </p>
                <p data-id="element-456">
                  Almacenan información para que el usuario acceda al servicio
                  con características personalizadas, como el idioma o región.
                </p>
              </div>

              <div data-id="element-457">
                <p className="font-semibold text-gray-800 mb-1" data-id="element-458">
                  C. Cookies de análisis o rendimiento:
                </p>
                <p data-id="element-459">
                  Nos permiten conocer el comportamiento de los visitantes para
                  mejorar el sitio. Usamos herramientas como Google Analytics u
                  otras similares.
                </p>
              </div>

              <div data-id="element-460">
                <p className="font-semibold text-gray-800 mb-1" data-id="element-461">
                  D. Cookies de publicidad o marketing:
                </p>
                <p data-id="element-462">
                  Recopilan información sobre tus hábitos de navegación para
                  mostrarte anuncios relevantes en nuestros sitios o en otros.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-463">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-464">
              4. ¿CUÁNTO TIEMPO PERMANECEN ACTIVAS?
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-465">
              <li data-id="element-466">
                <strong data-id="element-467">Cookies de sesión:</strong> se eliminan al cerrar el
                navegador.
              </li>
              <li data-id="element-468">
                <strong data-id="element-469">Cookies persistentes:</strong> permanecen en tu
                dispositivo hasta que las elimines o expiren.
              </li>
            </ul>
          </section>

          <section data-id="element-470">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-471">
              5. ¿CÓMO PUEDES CONTROLAR LAS COOKIES?
            </h3>
            <p className="mb-4" data-id="element-472">
              Al ingresar por primera vez a nuestro sitio, se te mostrará un
              aviso de cookies. Puedes aceptar todas, rechazarlas o
              configurarlas según tu preferencia.
            </p>
            <p className="mb-3" data-id="element-473">
              Además, puedes modificar la configuración de cookies desde tu
              navegador en cualquier momento:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-474">
              <li data-id="element-475">
                <strong data-id="element-476">Google Chrome:</strong> Configuración de cookies
              </li>
              <li data-id="element-477">
                <strong data-id="element-478">Mozilla Firefox:</strong> Administrar cookies
              </li>
              <li data-id="element-479">
                <strong data-id="element-480">Safari:</strong> Soporte de Safari
              </li>
              <li data-id="element-481">
                <strong data-id="element-482">Microsoft Edge:</strong> Privacidad y servicios
              </li>
            </ul>
          </section>

          <section data-id="element-483">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-484">
              6. COOKIES DE TERCEROS
            </h3>
            <p className="mb-3" data-id="element-485">
              Algunas cookies pueden ser instaladas por servicios de terceros
              utilizados en nuestro sitio (como redes sociales, plataformas de
              video, servicios de estadísticas, etc.). No tenemos control
              directo sobre ellas. Te recomendamos revisar sus respectivas
              políticas:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-486">
              <li data-id="element-487">
                <strong data-id="element-488">Google:</strong> Política de privacidad
              </li>
              <li data-id="element-489">
                <strong data-id="element-490">Meta (Facebook / Instagram):</strong> Política de
                cookies
              </li>
            </ul>
          </section>

          <section data-id="element-491">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-492">
              7. CAMBIOS EN ESTA POLÍTICA
            </h3>
            <p data-id="element-493">
              Podemos actualizar esta Política de Cookies en cualquier momento.
              Te notificaremos en nuestro sitio web cuando se hagan cambios
              relevantes.
            </p>
          </section>

          <section data-id="element-494">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-495">
              8. CONTACTO
            </h3>
            <p data-id="element-496">
              Si tienes dudas sobre nuestra política de cookies, puedes
              escribirnos a:{' '}
              <span className="font-medium text-emerald-600" data-id="element-497">
                contacto@benefica.net
              </span>
            </p>
          </section>

          <section data-id="element-498">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-499">
              9. VIGENCIA
            </h3>
            <p data-id="element-500">
              La vigencia de estas Políticas es desde el 21 de noviembre de 2025
              y permanecerá vigente hasta que exista una nueva versión que la
              reemplace.
            </p>
          </section>

          <div className="pt-8 mt-8 border-t border-gray-200 text-sm text-gray-500" data-id="element-501">
            Última actualización: 21 de noviembre de 2025
          </div>
        </div>
      </div>
    </div>;
}